// @ts-nocheck
import React from "react";
import styled from 'styled-components';
import Tabs from "../../components/Tabs";
import {useHistory} from "react-router-dom";
import { useFlag } from "../../lib/flags";
import Menu from "../../components/Menu";

export function AdminTabs() {
  const history = useHistory();
  const activeTab = history.location.pathname;
  const themeFlag = useFlag('ADMIN_APPEARANCE');
  const apiAccessFlag = useFlag('API_ACCESS');

  return (
    <StyledTabs>
      {themeFlag.enabled && <Tabs.Tab to="/admin/appearance" active={activeTab === "/admin" || activeTab === "/admin/appearance"}>Theme</Tabs.Tab>}
      <Tabs.Tab
        id="audit-log-tab"
        active={(themeFlag.disabled && activeTab === '/admin') || activeTab.startsWith("/admin/auditlog")}
        menu={
          <Menu>
            <Menu.Option to="/admin/auditlog/answers">Changed Answers</Menu.Option>
            <Menu.Option to="/admin/auditlog/deletions">Deleted Rows</Menu.Option>
            <Menu.Option to="/admin/auditlog/comments">Overall Comments</Menu.Option>
          </Menu>
        }>
        Audit Logs
      </Tabs.Tab>
      {apiAccessFlag.enabled && (
        <Tabs.Tab to="/admin/service-accounts" active={activeTab === "/admin/service-accounts"}>Service Accounts</Tabs.Tab>
      )}
    </StyledTabs>
  )
}

const StyledTabs = styled(Tabs)`
  margin-bottom: 2rem;
`;